import type { CompanyStatus } from "@/lib/types";

export const STATUS_LABEL: Record<CompanyStatus, string> = { lead: "Lead", customer: "Kunde", former: "Ehemalig" };

export type SevdeskLink = "unlinked" | "named" | "missing" | "unknown";

/**
 * "missing" only when sevDesk answered (no warnings) and the linked contact has no name —
 * an unreachable sevDesk must not claim the contact is gone ("unknown" instead).
 */
export function sevdeskLink(c: { sevdeskContactId: number | null; sevdeskName: string | null }, reachable: boolean): SevdeskLink {
  if (c.sevdeskContactId === null) return "unlinked";
  if (c.sevdeskName) return "named";
  return reachable ? "missing" : "unknown";
}
